import styled from 'styled-components';

interface ModalProps {
  isVisible: boolean
}

export const Container = styled.div<ModalProps>`
  position: absolute;
  z-index: 9;
  height: calc(100vh - 57px);
  width: calc(100vw - 200px);
  background-color: rgba(0, 0, 0, 0.1);
  display: ${(props) => props.isVisible ? 'flex' : 'none'};
  flex-direction: column;  
  justify-content: center;
  align-items: center;

  @media (max-width: 900px) {
    height: calc(100vh - 114px);
    width: 100vw;
  }

  div {
    background-color: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.text};
    width: 45%;
    padding: 30px 20px;
    border-radius: 5px;
    max-height: 90vh; 
    display: flex;
    flex-direction: column;
    -ms-overflow-style: none;  
    scrollbar-width: none;
    overflow-y: scroll;
    overflow-x: hidden;
    border: 2px solid ${({ theme }) => theme.text};

    @media (max-width: 900px) {
      width: 50%;
    }

    @media (max-width: 700px) {
      width: 60%;
    }

    @media (max-width: 600px) {
      width: 70%;
    }

    @media (max-width: 500px) {
      width: 80%;
    }

    @media (max-width: 400px) {
      width: 90%;
    }

    ::-webkit-scrollbar {
      display: none;
    }

    button :hover{
      filter: brightness(1.1);
    }
  }

  header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    vertical-align: middle;
    justify-content: space-between;

     h1 {
      color: ${({ theme }) => theme.text};
      font-size: 1.7rem;
     }

     button {
       outline: none;
       border: none;
       color: ${({ theme }) => theme.text};
       font-size: 1.7rem;
       background-color: transparent;
       margin-top: -20px;
     }
  }

  main {
    justify-content: center;
    align-items: center;

    button {
      outline: none;
      background-color: transparent;
      width: 85%;
      text-align: center;
      align-items: center;
      justify-content: center;
      border: 1px solid;
      border-image-slice: 1;
      border-width: 4px;

      h1 {
        padding: 0;
        margin: 0;
        font-size: 1.6rem;
        color: ${({ theme }) => theme.text};
      }
    }

    button.BluePurple {
      border-image-source: linear-gradient(to top, rgba(114, 209, 254,1), rgba(134,79,151,1));
    }

    button.YellowPurple {
      border-image-source: linear-gradient(to top, rgba(134,79,151,1), rgba(255,180,72,1));
    }

    button.RedPink {
      border-image-source: linear-gradient(to top, rgba(250,42,192,1) 0%, rgba(240,9,9,1) 100%);
    }

    button.BlueGreen {
      border-image-source: linear-gradient(to top, rgba(23,155,231,1) 0%, rgba(21,237,128,1) 100%);
    }

    button.Fire {
      border-image-source: linear-gradient(to top, rgba(237,27,27,1) 12%, rgba(242,111,0,1) 52%, rgba(242,214,8,1) 87%);
    }

    button.GrayCian {
      border-image-source: linear-gradient(to top, rgba(96,96,96,1) 30%, rgba(21,237,207,1) 100%);
    }

    button.PinkGreen {
      border-image-source: linear-gradient(to top, rgba(233,11,189,1) 14%, rgba(9,240,65,1) 100%);
    }

    button.BluePink {
      border-image-source: linear-gradient(to top, rgba(34,150,245,1) 0%, rgba(250,78,221,1) 74%);
    }
  }
`